type ModalFooterProps = {
  children: any;
};

export const ModalFooter: React.FC<ModalFooterProps> = ({ children }) => {
  return <div className="marketplace--modal-footer">{children}</div>;
};
